module.exports = __webpack_public_path__ + "img/team2.fe4a26b5.jpg";